module.exports = __webpack_public_path__ + "static/media/features-auth.f25cc82e.svg";